import { ApiEndpointBuilder } from "@/services/api/types";
import { User } from "@/types/user";

const getUserByIdEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.query<User, { id: string }>({
    query: request => {
      return {
        url: `/users/${request.id}`,
        method: "GET",
      };
    },
    providesTags: result => {
      return result ? [{ type: "user", id: result.id }] : [{ type: "user" }];
    },
  });
};

export default getUserByIdEndpoint;
